import React from 'react'
import {ServerConfig} from 'config'

import PaginatedList from '../../components/PaginatedList/PaginatedList'

const Customers = () => {
  const non_editable_fields = [
    ["id", "id", ""],
    ["first_name", "First Name"],
    ["last_name", "Last Name"],
    //["street", "Street"],
    //["zip", "ZipCode"],
    ["city", "City"],
    ["state", "State"],
    ["phone_number", "Phone Number"]
  ];

  // Tenants can only update the customer's email
  const editable_fields = [
    ["email", "Email"],
  ];

  return (
    <>
      <PaginatedList
        list_get_url={`${ServerConfig.SERVER_URL}/tenant/customer/`}
        detail_get_url={`${ServerConfig.SERVER_URL}/tenant/customers/`}
        detail_put_url={`${ServerConfig.SERVER_URL}/tenant/customers/`}

        column_names={["id", "first_name", "last_name", "city", "email", "phone_number", "association_type"]}
        header_names={["id", "First name", "Last name", "City", "Email", "Phone number", "Association"]}

        optional_column_names={[]}
        optional_header_names={[]}

        filter_inputs={[]}

        editable_fields={editable_fields}
        non_editable_fields={non_editable_fields}
        //show_machine_stats={true}
      />
    </>
  )
}

export default Customers
